<template >
    <transition name="fade" mode="out-in">
        <div>
            <ul class="submenu-sections" >
                <router-link tag="li" :to="{name:'DayTemplateDetails', params:{dayTemplateUid:params.dayTemplateUid}}">
                    <a><h4><span class="text">{{Translations.sections.dayTemplates.details.menu.schedule}}</span></h4></a>
                </router-link>
            </ul>
        </div>
    </transition>
</template>
<script >
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import Translations from '@/store/translations';

    export default {
        name: "WeekTemplateMenu",
        store,
        components: {
        },
        computed: {
            Translations: () => Translations,
            params: function() { return this.$route.params; },
        },
    }
</script>

<style scoped>
</style>
